import { GetterTree } from 'vuex'
import { State } from '@/store'
import Account from '@/api/models/Account'
import Brand from '@/api/models/Brand'
import Campaign from '@/api/models/Campaign'
import Reference from '@/api/models/Reference'
import Settings from '@/api/models/Settings'
import References from '@/api/models/References'
import WarehousesMapping from '@/api/models/WarehousesMapping'
import OrderStatusesDto from '@/api/dto/OrderStatusesDto'
import ReturnStatusesDto from '@/api/dto/ReturnStatusesDto'
import PaymentTypesDto from '@/api/dto/PaymentTypesDto'
import CampaignReferences from '@/api/models/CampaignReferences'
import SettingsMapping from '@/api/models/SettingsMapping'
import CatalogManagementDto from '@/api/dto/CatalogManagementDto'

export const getters: GetterTree<State, State> = {
    isLoading: (state: State): boolean => {
        return state.loading
    },
    brand: (state: State): Brand|undefined => {
        return state.brand
    },
    accounts: (state: State): Array<Account> => {
        return state.accounts
    },
    getCurrentAccount: (state: State): Account|undefined => {
        return state.accounts.find((account: Account) => account.id === state.currentAccount)
    },
    currentAccount: (state: State): number|undefined => {
        return state.currentAccount
    },
    campaigns: (state: State): Array<Campaign> => {
        return state.campaigns
    },
    currentCampaign: (state: State): number|undefined => {
        return state.currentCampaign
    },
    sites: (state: State): Array<Reference> => {
        return state.sites
    },
    settings: (state: State): Settings => {
        return state.settings
    },
    references: (state: State): References => {
        return state.references
    },
    campaignReferences: (state: State): CampaignReferences => {
        return state.campaignReferences
    },
    priceLink: (state: State): string => {
        return state.priceLink
    },
    orderStatuses: (state: State): OrderStatusesDto => {
        return state.orderStatuses
    },
    returnOrderStatuses: (state: State): ReturnStatusesDto => {
        return state.returnOrderStatuses
    },
    paymentTypes: (state: State): PaymentTypesDto => {
        return state.paymentTypes
    },
    warehouses: (state: State): Array<WarehousesMapping> => {
        return state.warehouses
    },
    costs: (state: State): Array<SettingsMapping> => {
        return state.costs
    },
    catalogManagementMapping: (state: State): CatalogManagementDto => {
        return state.catalogMapping
    },
    notificationKey: (state: State): string => {
        return state.notificationKey
    }
}
